/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AclfunctionAf } from '../../models/aclfunction-af';

export interface GetAllAclFunctions$Params {
}

export function getAllAclFunctions(http: HttpClient, rootUrl: string, params?: GetAllAclFunctions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AclfunctionAf>>> {
  const rb = new RequestBuilder(rootUrl, getAllAclFunctions.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AclfunctionAf>>;
    })
  );
}

getAllAclFunctions.PATH = '/api/AclRole/aclFunctions';
